import { useTranslation } from 'react-i18next';
import checkedInIcon from '../static/img/DailyCheckin/iconDailyCheckedIn.svg';
import currentCheckInIcon from '../static/img/DailyCheckin/iconCurrentDayCheckIn.svg';
import notCheckedInIcon from '../static/img/DailyCheckin/iconNotCheckedIn.svg';

import dayClaimedIcon from '../static/img/DailyCheckin/iconDayClaimed.svg';
import dayCurrentIcon from '../static/img/DailyCheckin/iconDayCurrent.svg';
import dayCurrentInvertIcon from '../static/img/DailyCheckin/iconDayCurrent_invert.svg';
import dayNotClaimedInvert from '../static/img/DailyCheckin/iconDayNotClaimed_invert.svg';


import dayNotClaimedIcon from '../static/img/DailyCheckin/iconDayNotClaimed.svg';
import styles from '../static/styles/DailyCheckin.module.css';

const DayItem = ({ day, activeDay, rewardAmount }) => {
  const { t } = useTranslation();
  let status;
  if (day < activeDay) {
    status = 'claimed';
  } else if (day === activeDay) {
    status = 'current';
  } else {
    status = 'locked';
  }

  let backgroundIcon;
  if (status === 'claimed') {
    backgroundIcon = checkedInIcon;
  } else if (status === 'current') {
    backgroundIcon = currentCheckInIcon;
  } else {
    backgroundIcon = notCheckedInIcon;
  }

  let headerIcon;
  if (status === 'claimed') {
    headerIcon = dayClaimedIcon;
  } else if (status === 'current') {
    headerIcon = dayCurrentIcon;
  } else {
    headerIcon = dayNotClaimedIcon;
  }

  let headerIconInvert;
  if (status === 'claimed') {
    headerIconInvert = dayClaimedIcon;
  } else if (status === 'current') {
    headerIconInvert = dayCurrentInvertIcon;
  } else {
    headerIconInvert = dayNotClaimedInvert;
  }

  return (
    <div className={styles.dayItem}>
      <div className={styles.checkinHeader}>
        <div
          className={styles.checkinTab}
          style={{ backgroundImage: `url(${headerIcon})` }}
        >
          {t('day_item.day_number', { count: day })}
        </div>
      </div>

      <div
        className={styles.checkinContent}
        style={{ backgroundImage: `url(${backgroundIcon})` }}
      >
      </div>

      <div className={styles.checkinHeader}>
        <div
          className={styles.checkinTab}
          style={{ backgroundImage: `url(${headerIconInvert})` }}
        >
          {t('day_item.credits_amount', { count: rewardAmount })}
        </div>
      </div>
    </div>
  );
};

export default DayItem;